import React, { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { CheckOutlined, LinkOutlined } from '@ant-design/icons';
// Api
import getEnvVariables from 'api/env';
// Ui
import { errorNotification } from 'ui/Notification';
// Styles
import styles from './AdminCreateUserForm.module.scss';

const CREATOR_SIGNUP_LINK = `${getEnvVariables.REACT_APP_WEB_PORTAL_URL}/creator-signup`;
const COPIED_STATE_DURATION_MS = 2000;

const CreatorSignupLink = (): JSX.Element => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return;

    const timeout = setTimeout(
      () => setCopied(false),
      COPIED_STATE_DURATION_MS
    );

    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(CREATOR_SIGNUP_LINK);

      setCopied(true);
    } catch (error) {
      errorNotification('Could not copy text');
    }
  };

  return (
    <div className={styles.creatorSignupLink}>
      <span className={styles.creatorSignupLabel}>
        Invite creator through the link
      </span>

      <Tooltip title={copied ? 'Copied!' : 'Copy link'}>
        <Button
          shape="circle"
          icon={
            copied ? (
              <CheckOutlined className={styles.copiedIcon} />
            ) : (
              <LinkOutlined />
            )
          }
          onClick={handleCopyClick}
          aria-label="Copy creator signup link"
        />
      </Tooltip>
    </div>
  );
};

export default CreatorSignupLink;
